import {AppConfig} from "../../../config";
import {HttpServer} from "../../../net/http_server";

export const addArbiterJson = (addArbiter: string, number: string): string => {
    return JSON.stringify({
        domain: {
            name: addArbiter,
            chainId: AppConfig.chainId.toString(),
        },
        message: {
            method: addArbiter,
            content: {
                user_id: HttpServer.account,
                number: parseInt(number),
            }
        },
        primaryType: 'Place',
        types: {
            EIP712Domain: [
                {name: 'name', type: 'string'},
                {name: 'chainId', type: 'uint256'},
            ],
            Place: [
                {name: 'content', type: 'Model'},
                {name: 'method', type: 'string'},
            ],
            Model: [
                {name: 'user_id', type: 'string'},
                {name: 'number', type: 'uint256'},
            ],

        }
    });
}
